const development = {
    domain :'https://console.media.megazone.com',
    host: {         
        api :"https://sx7bqjcob9.execute-api.ap-northeast-2.amazonaws.com/dev"
        // api:"https://mq2zyc5ewh.execute-api.ap-southeast-1.amazonaws.com/atomy-sg"
    },
    playerEndpoint: "http://mzc-cm-dev-players.s3-website.ap-northeast-2.amazonaws.com/",
    deployDestination: "s3://mzc-cm-dev-shared-videos",
    profile: "development"
};

export default development;
